import { Grid, type Theme } from '@mui/material';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import { useSelectedLinkContext } from 'contexts/SelectedLinkContext';
import { isSelfLink } from 'utils/link';
import AdminChannelLinkSelect from 'views/ChannelLink/AdminChannelLinkSelect';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: COLORS.DARKER_BLUE,
    padding: '10px 30px',

    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  profileText: {
    fontSize: 14,
    fontWeight: 'bold',
  },
}), { name: 'AdminHeader' });

const AdminHeaderPure = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid alignItems="center" container>
        <Grid item md={8} xs={12}>
          <AdminChannelLinkSelect />
        </Grid>
      </Grid>
    </div>
  );
};

const AdminHeader = (): JSX.Element | null => {
  const isSmallScreen = useSmallDesktopScreen();
  const { selectedLink } = useSelectedLinkContext();

  if (isSelfLink(selectedLink) || isSmallScreen) {
    return null;
  }

  return <AdminHeaderPure />;
};

export default AdminHeader;
